export default __webpack_public_path__ + "static/media/b065b800cee5ad0f4d85a151571054771600815861922.1fbefda2.webp";